import { render, staticRenderFns } from "./incorrect.vue?vue&type=template&id=5cb124d2&scoped=true&"
import script from "./incorrect.vue?vue&type=script&lang=js&"
export * from "./incorrect.vue?vue&type=script&lang=js&"
import style0 from "./incorrect.vue?vue&type=style&index=0&id=5cb124d2&prod&lang=css&"
import style1 from "./incorrect.vue?vue&type=style&index=1&id=5cb124d2&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb124d2",
  null
  
)

export default component.exports